import { c as _c } from "react/compiler-runtime";
import { useResizeObserver } from '@react-hookz/web/useResizeObserver/index.js';
import { useThrottledCallback } from '@react-hookz/web/useThrottledCallback/index.js';
import { useEffect, useRef, useState } from 'react';
export function useElementOverflow(direction, enabled) {
  const $ = _c(9);
  const [overflow, setOverflow] = useState(false);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] !== direction) {
    t0 = () => {
      const element = ref.current;
      if (element) {
        const rects = element.getBoundingClientRect();
        if (direction === "vertical") {
          setOverflow(rects.height < element.scrollHeight);
        } else {
          setOverflow(rects.width < element.scrollWidth);
        }
      }
    };
    t1 = [direction];
    $[0] = direction;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const measureOverflow = useThrottledCallback(t0, t1, 16);
  let t2;
  let t3;
  if ($[3] !== enabled || $[4] !== measureOverflow) {
    t2 = () => {
      if (enabled) {
        measureOverflow();
      }
    };
    t3 = [measureOverflow, enabled];
    $[3] = enabled;
    $[4] = measureOverflow;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  useResizeObserver(ref, measureOverflow, enabled);
  let t4;
  if ($[7] !== overflow) {
    t4 = {
      overflow,
      ref
    };
    $[7] = overflow;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}